import { postRequest, deleteRequest, fileRequest, patchRequest } from "../helpers/fetchHandler"
import {
  CREATE_GUIDE_LOADING,
  CREATE_GUIDE_SUCCESS,
  CREATE_GUIDE_FAILED,
  UPDATE_GUIDE_LOADING,
  UPDATE_GUIDE_SUCCESS,
  UPDATE_GUIDE_FAILED,
  DELETE_GUIDE_LOADING,
  DELETE_GUIDE_SUCCESS,
  DELETE_GUIDE_FAILED,
  // EDIT_GUIDE_SELECTED,
  UPLOAD_IMAGE_LOADING,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILED,
  UPLOAD_VIDEO_LOADING,
  UPLOAD_VIDEO_SUCCESS,
  UPLOAD_VIDEO_FAILED
} from "../constants/actionTypes"

export function createGuide(data) {
  return async dispatch => {
    dispatch({ type: CREATE_GUIDE_LOADING })

    const url = "/api/v1/guides"
    return postRequest({ url, data, auth: true })
      .then(response => dispatch({ type: CREATE_GUIDE_SUCCESS, payload: response }))
      .catch(error => {
        dispatch({ type: CREATE_GUIDE_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function updateGuide(id, data) {
  return async dispatch => {
    dispatch({ type: UPDATE_GUIDE_LOADING })

    const url = "/api/v1/guides/" + id
    return patchRequest({ url, data, auth: true })
      .then(response => dispatch({ type: UPDATE_GUIDE_SUCCESS, payload: response }))
      .catch(error => {
        dispatch({ type: UPDATE_GUIDE_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function deleteGuide(id) {
  return async dispatch => {
    dispatch({ type: DELETE_GUIDE_LOADING })

    const url = "/api/v1/guides/" + id
    return deleteRequest({ url, auth: true })
      .then(() => dispatch({ type: DELETE_GUIDE_SUCCESS, meta: { id } }))
      .catch(error => {
        dispatch({ type: DELETE_GUIDE_FAILED, error })
        return Promise.reject(error)
      })
  }
}

function saveImages(images, teamId, guideId) {
  return async dispatch => {
    dispatch({ type: UPLOAD_IMAGE_LOADING })

    const data = new FormData()
    data.append("teamId", teamId)
    data.append("guideId", guideId)
    images.forEach(image => {
      data.append("images", image, image.name)
    })

    const url = "/api/v1/files/uploadImages"
    return fileRequest({ url, data, auth: true })
      .then(response => dispatch({ type: UPLOAD_IMAGE_SUCCESS, payload: response.results }))
      .catch(error => {
        dispatch({ type: UPLOAD_IMAGE_FAILED, error })
        return Promise.reject(error)
      })
  }
}

function saveVideos(videos, teamId, guideId) {
  return async dispatch => {
    dispatch({ type: UPLOAD_VIDEO_LOADING })

    const data = new FormData()
    data.append("teamId", teamId)
    data.append("guideId", guideId)
    videos.forEach(video => {
      data.append("videos", video, video.name)
    })

    const url = "/api/v1/files/uploadVideos"
    return fileRequest({ url, data, auth: true })
      .then(response => dispatch({ type: UPLOAD_VIDEO_SUCCESS, payload: response.results }))
      .catch(error => {
        dispatch({ type: UPLOAD_VIDEO_FAILED, error })
        return Promise.reject(error)
      })
  }
}

export function addImageToGuide(images, guideId) {
  return (dispatch, getState) => {
    const state = getState()

    const destination = state.destinations.destinations.find(x => x.id === state.destinations.selectedDestinationId)
    const guide = destination.guides.find(x => x.id === guideId)

    if (!guide) {
      Promise.reject("Missing guide")
    }

    return dispatch(saveImages(images, guide.ownerTeamId, guideId))
      .then(imagesResponse => {
        const images = imagesResponse.payload.success.map(image => ({
          data: {
            id: image.id,
            url: image.url,
            thumbnail: image.thumbnail
            // caption: {fi: "", en: ""}
          },
          type: "image"
        }))

        const updatedGuide = {
          ...guide,
          content: {
            ...guide.content,
            blocks: [...guide.content.blocks, ...images]
          }
        }

        return updatedGuide
      })
      .then(guide => dispatch(updateGuide(guide.id, guide)))
      .catch(error => Promise.reject(error))
  }
}

export function addVideoToGuide(videos, guideId) {
  return (dispatch, getState) => {
    const state = getState()

    const destination = state.destinations.destinations.find(x => x.id === state.destinations.selectedDestinationId)
    const guide = destination.guides.find(x => x.id === guideId)

    if (!guide) {
      Promise.reject("Missing guide")
    }

    return dispatch(saveVideos(videos, guide.ownerTeamId, guideId))
      .then(videosResponse => {
        const videos = videosResponse.payload.success.map(video => ({
          data: {
            id: video.id,
            url: video.url,
            thumbnail: video.thumbnail
            // caption: {fi: "", en: ""}
          },
          type: "video"
        }))

        const updatedGuide = {
          ...guide,
          content: {
            ...guide.content,
            blocks: [...guide.content.blocks, ...videos]
          }
        }

        return updatedGuide
      })
      .then(guide => dispatch(updateGuide(guide.id, guide)))
      .catch(error => Promise.reject(error))
  }
}
